import React from "react";
import shouldShowGlobalBanner from "helpers/should-show-global-banner";
import ImageBanner from "components/image-banner";
import RenderModules from "helpers/render-modules";

const GlobalBanner = ({ globalBannerSettings, path }) => {
    if (!path) return null;

    const modules = globalBannerSettings?.modules;
    const hasModules = modules?.length > 0;

    return (
        shouldShowGlobalBanner(globalBannerSettings?.showOn, path) && (
            <div className="mb-2 md:mb-[12px] md:mt-[1.5em] global-banner">
                {hasModules ? (
                    <RenderModules modules={modules} />
                ) : (
                    <ImageBanner data={globalBannerSettings?.imageBanner} />
                )}
            </div>
        )
    );
};

export default GlobalBanner;
